<svg width="15" height="14" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.47949 19H22.4795" stroke="#143545" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M2.47949 12H22.4795" stroke="#143545" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M2.47949 5H22.4795" stroke="#143545" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
</svg>
